<!--首页-->
<template>
    <div class="id">
        <div v-html="content"></div>
    </div>
</template>
<script>
import { get } from '@/http/request'

export default {
    components: {
    },
    data() {
        return {
            content: '',
        };
    },
    mounted() {
        this.checkDevice()
    },
    beforeUnmount() { },
    methods: {
        checkDevice() {
            get(this.$apis.getConfig).then(res => {
                if (res.code != 1) return
                this.content = res.data.safe.content
            })
        }
    },
};
</script>
<style lang="less" scoped>
.id {
    color: #fff;
    padding: 20px;
    padding-bottom: 0px;
    padding-top: 60px;

    .van-cell {
        background-color: #000 !important;
        border: 1px solid #3e444c;
        color: #3e444c !important;
        font-size: 26px;
        padding: 30px 20px;
    }

    .van-cell::after {
        border-bottom: 0px solid #000;
    }

    ::v-deep .van-field__control {
        color: #fff !important;
    }

    .title {
        display: inline-block;
        background-color: #00f0ff;
        padding: 20px 34px;
        border-radius: 20px;
        font-size: 28px;
        margin-top: 40px;
    }

    .account {
        padding: 30px 0;
    }

    .van-checkbox {
        padding: 40px 0;
        font-size: 16px;
    }

    ::v-deep .van-checkbox__label {
        margin-left: 26px !important;
        font-size: 26px;
    }

    .btn {
        cursor: pointer;
        color: #fff;
        background-color: #00f0ff;
        text-align: center;
        padding: 20px 0;
        border-radius: 10px;
    }

    .register {
        color: #00f0ff;
        padding-top: 40px;
    }

    .forget {
        color: #00f0ff;
        padding-top: 40px;
    }

}
</style>
